import axios from "axios";
import { IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useUser } from './UserContext';
import { useMachine } from "./context/MachineContext";
import { LogOut } from 'lucide-react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LogoutButton = ({ username }) => {
  const navigate = useNavigate();
  const { setUsername: setGlobalUsername } = useUser();
  const { setMachineCode: setGlobalMachineCode } = useMachine();

  const handleLogout = async () => {
    try {
      const logoutTime = new Date().toISOString();

      await axios.post(`${API_BASE_URL}/logout`, { username, logoutTime });
      setGlobalUsername("");
      setGlobalMachineCode("");
      localStorage.removeItem('username');
      localStorage.removeItem('machineCode');
      navigate("/");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <Tooltip 
      title="Logout" 
      placement="right" 
      arrow
    >
      <IconButton
        onClick={handleLogout}
        sx={{
          width: 60,
          height: 60,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'error.main',
          color: 'error.main',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            bgcolor: 'error.main',
            color: '#fff',
            transform: 'scale(1.08)',
            boxShadow: 3,
          },
        }}
      >
        <LogOut size={26} />
      </IconButton>
    </Tooltip>
  );
};

export default LogoutButton;